import React from 'react';
import { Form, Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { addMessage } from '@features/messages/messagesSlice';
import { useDispatch } from 'react-redux';
import type { UploadFile } from 'antd';
import type { Dispatch } from 'redux';
import styles from './Test.module.scss';

// Define the form values interface
interface FormValues {
    upload: UploadFile[];
}

const Test: React.FC = () => {
    const [form] = Form.useForm<FormValues>();
    const dispatch = useDispatch<Dispatch>();

    // Antd's getValueFromEvent passes either the wrapped file list or the
    // raw array depending on event shape; both branches are valid inputs.
    const normFile = (e: UploadFile[] | { fileList: UploadFile[] }): UploadFile[] | undefined => {
        if (Array.isArray(e)) {
            return e;
        }
        return e?.fileList;
    };

    const onFinish = async (values: FormValues): Promise<void> => {
        console.log('Received values:', values);
    };

    // beforeUpload returns false to bypass antd's auto-upload — the file
    // argument is required by the type signature but unused here.
    const beforeUpload = (): boolean => {
        return false;
    };

    return (
        <div className={styles.container}>
            <Form<FormValues> form={form} onFinish={onFinish} layout="vertical">
                <Form.Item
                    name="upload"
                    label="Upload File"
                    valuePropName="fileList"
                    getValueFromEvent={normFile}
                    rules={[
                        {
                            required: true,
                            message: 'Please upload a file',
                        },
                    ]}
                >
                    <Upload beforeUpload={beforeUpload} listType="text">
                        <Button icon={<UploadOutlined />}>Select File</Button>
                    </Upload>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Submit Form and Upload
                    </Button>
                </Form.Item>
            </Form>

            <Button
                type="primary"
                onClick={() => {
                    // Get timestamp
                    const time = new Date().getTime();
                    dispatch(addMessage({ type: 'error', content: 'This is a success message' + time }));
                }}
            >
                add message
            </Button>

            {/* <img src="https://aotravel-resources.oss-cn-beijing.aliyuncs.com/images_activity/史蒂芬斯港海豚观赏快船巡游-60分钟_1932F9B7B38.png" /> */}
        </div>
    );
};

export default Test;
